import ReCAPTCHA from 'react-google-recaptcha'
import React from 'react'
import { recaptchaSiteKeyV2 } from 'shared/utils'

export const RecaptchaV2 = React.forwardRef((_, ref) => {
    return (
        <ReCAPTCHA size={'invisible'} ref={ref} sitekey={recaptchaSiteKeyV2} />
    )
})
